/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxSparkleA1Icon16Light } from './NatureFxSparkleA1Icon16Light';
import { NatureFxSparkleA1Icon16Regular } from './NatureFxSparkleA1Icon16Regular';
import { NatureFxSparkleA1Icon16Solid } from './NatureFxSparkleA1Icon16Solid';
import { NatureFxSparkleA1Icon20Light } from './NatureFxSparkleA1Icon20Light';
import { NatureFxSparkleA1Icon20Regular } from './NatureFxSparkleA1Icon20Regular';
import { NatureFxSparkleA1Icon20Solid } from './NatureFxSparkleA1Icon20Solid';
import { NatureFxSparkleA1Icon24Regular } from './NatureFxSparkleA1Icon24Regular';
import { NatureFxSparkleA1Icon24Solid } from './NatureFxSparkleA1Icon24Solid';
import { NatureFxSparkleA1Icon32Regular } from './NatureFxSparkleA1Icon32Regular';
import { NatureFxSparkleA1Icon64Regular } from './NatureFxSparkleA1Icon64Regular';
var sizes = {
    16: {
        light: NatureFxSparkleA1Icon16Light,
        regular: NatureFxSparkleA1Icon16Regular,
        solid: NatureFxSparkleA1Icon16Solid,
    },
    20: {
        light: NatureFxSparkleA1Icon20Light,
        regular: NatureFxSparkleA1Icon20Regular,
        solid: NatureFxSparkleA1Icon20Solid,
    },
    24: {
        regular: NatureFxSparkleA1Icon24Regular,
        solid: NatureFxSparkleA1Icon24Solid,
    },
    32: {
        regular: NatureFxSparkleA1Icon32Regular,
    },
    64: {
        regular: NatureFxSparkleA1Icon64Regular,
    },
};
export var NatureFxSparkleA1Icon = forwardRef('NatureFxSparkleA1Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
